import {useEffect} from 'react'

// Calculate browser scrollbar width and set it to --scrollbar-width CSS variable
const BrowserScrollbarWidth = () => {
    useEffect(() => {
        const setScrollbarWidth = () => {
            const scrollDiv = document.createElement('div')
            scrollDiv.style.visibility = 'hidden'
            scrollDiv.style.overflow = 'scroll'
            scrollDiv.style.msOverflowStyle = 'scrollbar'
            scrollDiv.style.width = '100px'
            scrollDiv.style.position = 'absolute'
            scrollDiv.style.top = '-9999px'
            document.body.appendChild(scrollDiv)

            const innerDiv = document.createElement('div')
            innerDiv.style.width = '100%'
            scrollDiv.appendChild(innerDiv)

            const scrollbarWidth = scrollDiv.offsetWidth - innerDiv.offsetWidth
            document.body.removeChild(scrollDiv)

            document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
        }

        setScrollbarWidth()
    }, [])
}

export default BrowserScrollbarWidth
